import { createContext, useContext } from "react";

export const PosthogEnabledContext = createContext(false);

export const usePostHogEnabled = (): boolean => {
  return useContext(PosthogEnabledContext);
};
